import { render } from "./ModulesField.vue?vue&type=template&id=50bc7e1a"
import script from "./ModulesField.vue?vue&type=script&lang=js"
export * from "./ModulesField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__